import { render } from "./UsagerPaiementPage.vue?vue&type=template&id=134dcdbf&ts=true"
import script from "./UsagerPaiementPage.vue?vue&type=script&lang=ts"
export * from "./UsagerPaiementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__